<template>
  <div class="container-fluid">
    <b-card no-body>
      <b-tabs cards v-model="tabIndex">
        <b-tab title="Report Query">
          <template v-slot:title>
            <span style="color: black">Report Query</span>
            <b-btn variant="link" size="sm" class="my-0" href="#">.</b-btn>
          </template>
          <report-query
            @clicked="newTab"
            :mainCategory="mainCategory"
            :initialCategoryId="initialCategoryId"
            :initialReportId="initialReportId"
          ></report-query>
        </b-tab>
        <b-tab v-for="(i, index) in tabsArray" :key="'dyn-tab-' + i" active>
          <template v-slot:title>
            <span style="color: black">{{
              i + 1 + " " + tabsNames[index]
            }}</span>
            <b-btn
              variant="link"
              size="sm"
              class="my-0"
              @click.prevent="closeTab(i)"
              style="color: red"
              href="#"
              >X</b-btn
            >
          </template>
          <div class="row" style="margin: 0">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <!-- <b-button
                        class="float-right mx-3"
                        variant="outline-danger"
                        size="sm"
                        @click="convertToPdf(index)"
                        style="float:right; font-size:1em; font-color:red"
                      >
                        PDF
              </b-button>-->
              <!-- <b-button
                        variant="outline-success"
                        size="sm"
                        @click="downloadExcel(index)"
                        style="float:right; font-size:1em; font-color:green"
                      >
                        Excel
              </b-button>-->
              <b-button
                variant="danger"
                small
                style="float: right; margin-bottom: 10px; margin-left: 10px"
                v-on:click="convertToPdf(index)"
                >PDF</b-button
              >
              <b-button
                variant="warning"
                small
                style="float: right; margin-bottom: 10px; margin-left: 10px"
                v-on:click="convertToPassbook(index)"
                >Bank Passbook</b-button
              >
              <json-excel
                :data="itemsArray[index]"
                :header="headerArray[index]"
                :stringifyLongNum="stringifylong"
                style="float: right"
              >
                <button
                  type="button"
                  style="float: right; margin-bottom: 10px"
                  class="btn btn-info waves-effect waves-light m-r-10"
                >
                  Excel
                </button>
              </json-excel>
            </div>
          </div>
          <loading
            :active.sync="isLoading"
            color="#5dbbda"
            loader="spinner"
            :is-full-page="fullPage"
            width:2
            height:2
          ></loading>

          <div class="row" style="margin-top: 10px">
            <div class="col-md-12">
              <div class="overflow-auto">
                <b-table
                  show-empty
                  selectable
                  select-mode="multi"
                  head-variant="dark"
                  empty-text="No records available."
                  stacked="md"
                  bordered
                  striped
                  style="font-size: 12px"
                  :items="itemsArray[index]"
                  :current-page="currentPage[index]"
                  :per-page="perPage[index]"
                  hover
                ></b-table>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-2">
              <span style="font-size: 0.875rem"
                >Total Rows: {{ totalRows[index] }}</span
              >
            </div>

            <div class="col-md-3">
              <b-form-group
                horizontal
                label="Per page"
                class="mb-0"
                label-size="sm"
                label-cols="3"
              >
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage[index]"
                  size="sm"
                />
              </b-form-group>
            </div>

            <div class="col-md-7">
              <b-pagination
                v-model="currentPage[index]"
                :total-rows="totalRows[index]"
                :per-page="perPage[index]"
                size="sm"
                style="float: right; margin-top: 0"
                limit="10"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// import { BIcon, BIconXCircle } from "bootstrap-vue";
import ReportQuery from "./ReportsQuery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
//import XLSX from "xlsx";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
import logger from "@/utils/logger";
import { normalizeResponseArray } from "@/utils/responseNormalizer";
// const base_url = process.env.VUE_APP_BASE_URL;

export default {
  components: { ReportQuery, JsonExcel, Loading },
  props: ["mainCategory", "initialCategoryId", "initialReportId"],
  data() {
    return {
      stringifylong:true,
      header:
        "MAHARASHTRA RAJYA ITAR MAGASVARGIYA VITTA ANI VIKAS MAHAMANDAL LTD.",
      perPage: [],
      currentPage: [],
      pageOptions: [50, 100, 500],
      totalRows: [],
      tabIndex: 0,
      tabsArray: [],
      tabCounter: 0,
      tabsNames: [],
      itemsArray: [],
      headerArray: [],
      board_name: "",
      board_address1: "",
      board_address3: "",
      isLoading: false,
      fullPage: false,
    };
  },
  methods: {
    closeTab(x) {
      for (let i = 0; i < this.tabsArray.length; i++) {
        if (this.tabsArray[i] === x) {
          this.tabsNames.splice(i, 1);
          this.itemsArray.splice(i, 1);
          this.totalRows.splice(i, 1);
          this.perPage.splice(i, 1);
          this.currentPage.splice(i, 1);
          this.tabsArray.splice(i, 1);
          this.headerArray.splice(i, 1);
        }
      }
    },
    formatDateForHeader(value) {
      if (!value) return "";
      const dt = new Date(value);
      if (Number.isNaN(dt.getTime())) return String(value);
      return dt.toLocaleDateString("en-GB");
    },
    matchesFilterText(row, fields, filterValue) {
      const text = String(filterValue || "").trim().toLowerCase();
      if (!text) return true;
      return fields.some((field) => String(row[field] || "").toLowerCase().indexOf(text) !== -1);
    },
    toNumber(value) {
      const num = parseFloat(value);
      return Number.isNaN(num) ? 0 : num;
    },
    getStartOfDay(value) {
      if (!value) return null;
      const dt = new Date(value);
      if (Number.isNaN(dt.getTime())) return null;
      dt.setHours(0, 0, 0, 0);
      return dt;
    },
    getEndOfDay(value) {
      if (!value) return null;
      const dt = new Date(value);
      if (Number.isNaN(dt.getTime())) return null;
      dt.setHours(23, 59, 59, 999);
      return dt;
    },
    getClaimInterestSubsidyAmount(row) {
      return this.toNumber(
        row.RptAmount ||
        row.PaidAmount ||
        row.TotalPaidClaim ||
        row.EMIPaidAmt ||
        row.DisbursementAmount ||
        row.ApprovedAmount ||
        row.TotalClaimAmount ||
        row.ClaimPaidAmt
      );
    },
    getClaimReportViewLabel(view) {
      const labels = {
        beneficiary: "Beneficiary-wise Detailed",
        beneficiary_summary: "Beneficiary-wise Summary",
        passbook: "Bank Passbook Style",
        scheme: "Scheme-wise",
        district: "District-wise"
      };
      return labels[String(view || "").toLowerCase()] || view;
    },
    normalizeStatusText(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ")
        .replace(/progeje|projeje|progect|projec\b/g, "project");
    },
    resolveSelectedStatusFilter(reportFilter) {
      const filters = reportFilter || {};
      const keys = Object.keys(filters || {});
      let statusValue = null;

      for (let i = 0; i < keys.length; i++) {
        const key = String(keys[i] || "").toLowerCase();
        if (key.indexOf("status") === -1) continue;
        if (key.indexOf("owner") !== -1) continue;
        if (key.indexOf("validation") !== -1) continue;

        const value = filters[keys[i]];
        if (value === undefined || value === null) continue;
        const text = String(value).trim();
        if (!text || text === "0" || text.toLowerCase() === "all") continue;

        statusValue = value;
        break;
      }

      if (statusValue === null) {
        return { selectedStatusId: 0, selectedStatusText: "" };
      }

      const appStatuses = this.$store.getters.getapplicationStatusList || [];
      const claimStatuses = this.$store.getters.getclaimStatusList || [];
      const selectedStatusId = parseInt(statusValue, 10);

      if (!Number.isNaN(selectedStatusId) && selectedStatusId > 0) {
        const appMatch = appStatuses.find((s) => parseInt(s.Id || s.ApplicationStatusID || s.StatusID, 10) === selectedStatusId);
        const claimMatch = claimStatuses.find((s) => parseInt(s.Id || s.ApplicationStatusID || s.StatusID, 10) === selectedStatusId);
        const statusText = appMatch
          ? (appMatch.ApplicationStatus || appMatch.Status || appMatch.StatusName || "")
          : (claimMatch ? (claimMatch.ApplicationStatus || claimMatch.Status || claimMatch.StatusName || "") : "");

        return {
          selectedStatusId,
          selectedStatusText: this.normalizeStatusText(statusText),
        };
      }

      const normalizedText = this.normalizeStatusText(statusValue);
      const appMatchByText = appStatuses.find((s) => {
        const text = this.normalizeStatusText(s.ApplicationStatus || s.Status || s.StatusName || "");
        return text && text === normalizedText;
      });
      const claimMatchByText = claimStatuses.find((s) => {
        const text = this.normalizeStatusText(s.ApplicationStatus || s.Status || s.StatusName || "");
        return text && text === normalizedText;
      });

      const matchedId = appMatchByText
        ? parseInt(appMatchByText.Id || appMatchByText.ApplicationStatusID || appMatchByText.StatusID, 10)
        : (claimMatchByText ? parseInt(claimMatchByText.Id || claimMatchByText.ApplicationStatusID || claimMatchByText.StatusID, 10) : 0);

      return {
        selectedStatusId: Number.isNaN(matchedId) ? 0 : matchedId,
        selectedStatusText: normalizedText,
      };
    },
    rowMatchesSelectedStatus(row, selectedStatusId, selectedStatusText) {
      if (!selectedStatusId && !selectedStatusText) return true;

      const rowStatusId = parseInt(
        row.ApplicationStatusID || row.ApplicationStatusId || row.StatusID || row.AppStatusID || row.ApprovalStatusID || row.ClaimStatusID || row.ClaimPaymentStatusID || 0,
        10
      );

      if (!Number.isNaN(rowStatusId) && rowStatusId > 0 && selectedStatusId > 0) {
        return rowStatusId === selectedStatusId;
      }

      const rowStatusText = this.normalizeStatusText(
        row.ApplicationStatus || row.Status || row.ApplicationStatus1 || row.ClaimStatus || row.ClaimPaymentStatus || row.ApprovalStatus || ""
      );
      if (!rowStatusText) return false;
      if (!selectedStatusText) return false;

      return rowStatusText === selectedStatusText;
    },
    applyStrictStatusFilter(rows, rptqry) {
      const filters = (rptqry && rptqry.ReportFilter) || {};
      const { selectedStatusId, selectedStatusText } = this.resolveSelectedStatusFilter(filters);
      if (!selectedStatusId && !selectedStatusText) {
        return rows || [];
      }
      return (rows || []).filter((row) => this.rowMatchesSelectedStatus(row || {}, selectedStatusId, selectedStatusText));
    },
    isClaimReportQuery(rptqry) {
      const filters = (rptqry && rptqry.ReportFilter) || {};
      const reportName = String(this.$store.getters.getReportName || "").toLowerCase();
      return rptqry && (
        rptqry.ReportID == 24 ||
        rptqry.ReportID == 25 ||
        filters.report_family === "claim" ||
        reportName.indexOf("claim") !== -1 ||
        reportName.indexOf("subsidy") !== -1 ||
        reportName.indexOf("interest") !== -1 ||
        reportName.indexOf("passbook") !== -1
      );
    },
    buildClaimSubsidyRows(rptqry) {
      const filters = rptqry.ReportFilter || {};
      const request = {
        DistrictID: "00000000-0000-0000-0000-000000000000",
        BankID: "00000000-0000-0000-0000-000000000000",
        ClaimStatus: 0,
        ClaimPaidStatus: 0,
        LoanApplicationNo: null,
        LOINumber: null,
        UserLoginID: null,
        RecoStatus: 0,
        ClaimStartDate: filters.from_date || null,
        ClaimEndDate: filters.to_date || null,
        LoanType: filters.loan_type || 1,
        StatusOwner: "All"
      };

      const claimPromise = apis.ReadClaimEMIForApproval(request);
      return claimPromise.then((response) => {
        const rawRows = normalizeResponseArray(response);
        const startDate = this.getStartOfDay(filters.from_date);
        const endDate = this.getEndOfDay(filters.to_date);
        const amountFrom = this.toNumber(filters.amount_from);
        const amountTo = this.toNumber(filters.amount_to);
        const view = String(filters.report_view || "beneficiary").toLowerCase();

        let rows = rawRows.filter((row) => {
          const paymentDate = new Date(row.RptDt || row.EMIPaidDate || row.PaymentDate || row.ClaimDate || row.LOIDate || row.LastStatusDate || "");
          if (startDate && (!paymentDate || Number.isNaN(paymentDate.getTime()) || paymentDate < startDate)) return false;
          if (endDate && (!paymentDate || Number.isNaN(paymentDate.getTime()) || paymentDate > endDate)) return false;
          if (filters.beneficiary_name && !this.matchesFilterText(row, ["FullName", "BeneficiaryName"], filters.beneficiary_name)) return false;
          if (filters.claim_number && !this.matchesFilterText(row, ["ClaimEMIID", "ClaimNo", "LoanApplicationNo", "LOINumber"], filters.claim_number)) return false;
          if (filters.office_name && !this.matchesFilterText(row, ["BranchName", "LoanBranch", "BankName", "OfficeName"], filters.office_name)) return false;
          if (filters.district_name && !this.matchesFilterText(row, ["DistrictName", "District"], filters.district_name)) return false;

          const amount = this.getClaimInterestSubsidyAmount(row);
          if (filters.amount_from && amount < amountFrom) return false;
          if (filters.amount_to && amount > amountTo) return false;
          return true;
        });

        rows = rows.map((row) => {
          const claimAmount = this.toNumber(row.TotalClaimAmount || row.EMIPaidAmt || row.PrincipalAmt || row.InterestAmt);
          const approvedAmount = this.toNumber(row.ApprovedAmount);
          const paidAmount = this.toNumber(row.TotalPaidClaim || row.EMIPaidAmt || row.ApprovedAmount);
          const corpAmount = this.getClaimInterestSubsidyAmount(row);
          const mismatch = Math.abs(approvedAmount - paidAmount) > 0.01 || Math.abs(paidAmount - corpAmount) > 0.01;

          return {
            ...row,
            ClaimAmount: claimAmount.toFixed(2),
            ApprovedAmount: approvedAmount.toFixed(2),
            PaidAmount: paidAmount.toFixed(2),
            CorporationAmount: corpAmount.toFixed(2),
            Variance: (paidAmount - corpAmount).toFixed(2),
            ValidationStatus: mismatch ? "Mismatch" : "Validated"
          };
        });

        const validationMode = String(filters.validation_mode || "all").toLowerCase();
        if (validationMode === "validated") {
          rows = rows.filter((row) => row.ValidationStatus === "Validated");
        } else if (validationMode === "mismatch") {
          rows = rows.filter((row) => row.ValidationStatus === "Mismatch");
        }

        if (view === "scheme") {
          const grouped = {};
          rows.forEach((row) => {
            const scheme = String(row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType || "Unspecified").trim() || "Unspecified";
            if (!grouped[scheme]) {
              grouped[scheme] = { Scheme: scheme, BeneficiaryCount: 0, TotalAmount: 0, ValidatedCount: 0, DiscrepancyCount: 0, Districts: new Set() };
            }
            grouped[scheme].BeneficiaryCount += 1;
            grouped[scheme].TotalAmount += this.toNumber(row.CorporationAmount);
            if (row.ValidationStatus === "Validated") grouped[scheme].ValidatedCount += 1;
            else grouped[scheme].DiscrepancyCount += 1;
            if (row.DistrictName) grouped[scheme].Districts.add(String(row.DistrictName).trim());
          });
          return Object.keys(grouped).map((scheme, index) => ({
            SrNo: index + 1,
            Scheme: grouped[scheme].Scheme,
            BeneficiaryCount: grouped[scheme].BeneficiaryCount,
            ValidatedCount: grouped[scheme].ValidatedCount,
            DiscrepancyCount: grouped[scheme].DiscrepancyCount,
            Districts: Array.from(grouped[scheme].Districts).join(", "),
            InterestSubsidyAmount: grouped[scheme].TotalAmount.toFixed(2)
          })).sort((a, b) => b.BeneficiaryCount - a.BeneficiaryCount || a.Scheme.localeCompare(b.Scheme));
        }

        if (view === "beneficiary_summary") {
          const grouped = {};
          rows.forEach((row) => {
            const beneficiaryName = String(row.FullName || row.BeneficiaryName || "Unspecified").trim() || "Unspecified";
            const claimNumber = String(row.ClaimEMIID || row.ClaimNo || "").trim();
            if (!grouped[beneficiaryName]) {
              grouped[beneficiaryName] = {
                BeneficiaryName: beneficiaryName,
                ClaimNumbers: new Set(),
                Districts: new Set(),
                Offices: new Set(),
                Schemes: new Set(),
                AadhaarNumber: String(row.AdharNo || row.AadhaarNumber || "").trim(),
                ClaimAmount: 0,
                ApprovedAmount: 0,
                PaidAmount: 0,
                BeneficiaryCount: 0,
              };
            }

            grouped[beneficiaryName].BeneficiaryCount += 1;
            grouped[beneficiaryName].ClaimAmount += this.toNumber(row.ClaimAmount);
            grouped[beneficiaryName].ApprovedAmount += this.toNumber(row.ApprovedAmount);
            grouped[beneficiaryName].PaidAmount += this.toNumber(row.CorporationAmount);
            if (claimNumber) grouped[beneficiaryName].ClaimNumbers.add(claimNumber);
            if (row.DistrictName || row.District) grouped[beneficiaryName].Districts.add(String(row.DistrictName || row.District).trim());
            if (row.BranchName || row.LoanBranch || row.BankName || row.OfficeName) grouped[beneficiaryName].Offices.add(String(row.BranchName || row.LoanBranch || row.BankName || row.OfficeName).trim());
            if (row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType) grouped[beneficiaryName].Schemes.add(String(row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType).trim());
          });

          return Object.keys(grouped).map((name, index) => ({
            SrNo: index + 1,
            BeneficiaryName: grouped[name].BeneficiaryName,
            AadhaarNumber: grouped[name].AadhaarNumber,
            ClaimNumbers: Array.from(grouped[name].ClaimNumbers).join(", "),
            Districts: Array.from(grouped[name].Districts).join(", "),
            Offices: Array.from(grouped[name].Offices).join(", "),
            Schemes: Array.from(grouped[name].Schemes).join(", "),
            ClaimAmount: grouped[name].ClaimAmount.toFixed(2),
            ApprovedAmount: grouped[name].ApprovedAmount.toFixed(2),
            PaidAmount: grouped[name].PaidAmount.toFixed(2),
            Records: grouped[name].BeneficiaryCount,
          })).sort((a, b) => a.BeneficiaryName.localeCompare(b.BeneficiaryName));
        }

        if (view === "passbook") {
          const runningTotals = {};
          return rows
            .slice()
            .sort((a, b) => {
              const nameA = String(a.FullName || a.BeneficiaryName || "").toLowerCase();
              const nameB = String(b.FullName || b.BeneficiaryName || "").toLowerCase();
              if (nameA !== nameB) return nameA.localeCompare(nameB);
              const dateA = new Date(a.RptDt || a.EMIPaidDate || a.PaymentDate || a.ClaimDate || 0).getTime() || 0;
              const dateB = new Date(b.RptDt || b.EMIPaidDate || b.PaymentDate || b.ClaimDate || 0).getTime() || 0;
              if (dateA !== dateB) return dateA - dateB;
              return String(a.ClaimEMIID || a.ClaimNo || "").localeCompare(String(b.ClaimEMIID || b.ClaimNo || ""));
            })
            .map((row, index) => {
              const beneficiaryName = row.FullName || row.BeneficiaryName || "";
              const paymentAmount = this.toNumber(row.CorporationAmount);
              if (!runningTotals[beneficiaryName]) {
                runningTotals[beneficiaryName] = 0;
              }
              runningTotals[beneficiaryName] += paymentAmount;
              return {
                SrNo: index + 1,
                BeneficiaryName: beneficiaryName,
                AadhaarNumber: row.AdharNo || row.AadhaarNumber || "",
                PaymentDate: this.formatDateForHeader(row.RptDt || row.EMIPaidDate || row.PaymentDate || row.ClaimDate),
                Scheme: row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType || "",
                ClaimNumber: row.ClaimEMIID || row.ClaimNo || "",
                LoanApplicationNo: row.LoanApplicationNo || "",
                LOINumber: row.LOINumber || "",
                District: row.DistrictName || row.District || "",
                Office: row.BranchName || row.LoanBranch || row.BankName || row.OfficeName || "",
                InstallmentOrPeriod: row.InstallmentNo || row.EMINumber || row.EMIMonth || row.PaymentMonth || "",
                InterestSubsidyAmount: row.CorporationAmount,
                RunningTotal: runningTotals[beneficiaryName].toFixed(2),
                ValidationStatus: row.ValidationStatus,
                ReferenceNo: row.TransactionID || row.UTRNo || row.ReferenceNo || row.ClaimEMIID || ""
              };
            });
        }

        if (view === "district") {
          const grouped = {};
          rows.forEach((row) => {
            const district = String(row.DistrictName || row.District || "Unspecified").trim() || "Unspecified";
            if (!grouped[district]) {
              grouped[district] = { District: district, BeneficiaryCount: 0, TotalAmount: 0, ValidatedCount: 0, DiscrepancyCount: 0, Schemes: new Set() };
            }
            grouped[district].BeneficiaryCount += 1;
            grouped[district].TotalAmount += this.toNumber(row.CorporationAmount);
            if (row.ValidationStatus === "Validated") grouped[district].ValidatedCount += 1;
            else grouped[district].DiscrepancyCount += 1;
            if (row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType) {
              grouped[district].Schemes.add(String(row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType).trim());
            }
          });
          return Object.keys(grouped).map((district, index) => ({
            SrNo: index + 1,
            District: grouped[district].District,
            BeneficiaryCount: grouped[district].BeneficiaryCount,
            ValidatedCount: grouped[district].ValidatedCount,
            DiscrepancyCount: grouped[district].DiscrepancyCount,
            Schemes: Array.from(grouped[district].Schemes).join(", "),
            InterestSubsidyAmount: grouped[district].TotalAmount.toFixed(2)
          })).sort((a, b) => b.BeneficiaryCount - a.BeneficiaryCount || a.District.localeCompare(b.District));
        }

        return rows.map((row, index) => ({
          SrNo: index + 1,
          PaymentDate: this.formatDateForHeader(row.RptDt || row.EMIPaidDate || row.PaymentDate || row.ClaimDate),
          BeneficiaryName: row.FullName || row.BeneficiaryName || "",
          LoanApplicationNo: row.LoanApplicationNo || "",
          LOINumber: row.LOINumber || "",
          ClaimNumber: row.ClaimEMIID || row.ClaimNo || "",
          Scheme: row.SchemeName || row.SchemeType || row.LoanTypeName || row.LoanType || "",
          District: row.DistrictName || row.District || "",
          Office: row.BranchName || row.LoanBranch || row.BankName || "",
          AadhaarNumber: row.AdharNo || row.AadhaarNumber || "",
          ClaimAmount: row.ClaimAmount,
          ApprovedAmount: row.ApprovedAmount,
          PaidAmount: row.PaidAmount,
          CorporationAmount: row.CorporationAmount,
          Variance: row.Variance,
          ValidationStatus: row.ValidationStatus,
          InterestSubsidyAmount: row.CorporationAmount,
          BankName: row.BankName || "",
          BranchName: row.BranchName || "",
          Mobile: row.Mobile || "",
          Email: row.EmailID || "",
          Remarks: row.ClaimEMIID || row.ClaimStatus || ""
        }));
      });
    },
    newTab() {
      this.isLoading = true;
      this.tabsArray.push(this.tabCounter++);

      this.tabsNames.push(this.$store.getters.getReportName || "Report");
      let hdr = [
        "MAHARASHTRA RAJYA ITAR MAGASVARGIYA VITTA ANI VIKAS MAHAMANDAL LTD.",
        this.$store.getters.getReportName || "Report",
      ];

      let rptqry = this.$store.getters.getReportQuery || {};
      if (!rptqry || !rptqry.ReportID) {
        this.itemsArray.push([]);
        this.totalRows.push(0);
        this.perPage.push(10);
        this.currentPage.push(1);
        this.tabIndex = this.tabsArray.length;
        this.isLoading = false;
        return;
      }

      rptqry.ReportFilter = rptqry.ReportFilter || {};

      if (this.isClaimReportQuery(rptqry)) {
        const filters = rptqry.ReportFilter;
        if (filters.from_date || filters.to_date) {
          hdr.push("Date range : " + (filters.from_date || "") + " to " + (filters.to_date || ""));
        } else if (filters.financial_year) {
          hdr.push("Financial year : " + filters.financial_year);
        }
        if (filters.beneficiary_name) {
          hdr.push("Beneficiary : " + filters.beneficiary_name);
        }
        if (filters.claim_number) {
          hdr.push("Claim Number : " + filters.claim_number);
        }
        if (filters.office_name) {
          hdr.push("Office : " + filters.office_name);
        }
        if (filters.district_name) {
          hdr.push("District : " + filters.district_name);
        }
        if (filters.amount_from || filters.amount_to) {
          hdr.push("Amount : " + (filters.amount_from || "0") + " to " + (filters.amount_to || ""));
        }
        if (filters.report_view) {
          hdr.push("View : " + this.getClaimReportViewLabel(filters.report_view));
        }
        if (filters.validation_mode) {
          hdr.push("Validation : " + filters.validation_mode);
        }
      }
      const reportName = String(this.$store.getters.getReportName || "").toLowerCase();
      if (reportName.indexOf("loi") !== -1 || reportName.indexOf("letter of intent") !== -1) {
        const filters = rptqry.ReportFilter || {};
        if (filters.loi_period_type) {
          hdr.push("LOI Period : " + filters.loi_period_type);
        }
        if (filters.report_month) {
          hdr.push("Month : " + filters.report_month);
        }
        if (filters.financial_year) {
          hdr.push("Financial year : " + filters.financial_year);
        }
        if (filters.from_date || filters.to_date) {
          hdr.push("Date range : " + (filters.from_date || "") + " to " + (filters.to_date || ""));
        }
      }
      hdr.push(" ");
      this.headerArray.push(hdr);
      const claimReportMode = this.isClaimReportQuery(rptqry);
      const requestPromise = claimReportMode
        ? this.buildClaimSubsidyRows(rptqry)
        : apis.GetReportDetails(rptqry).then((response) => normalizeResponseArray(response));

      requestPromise.then((rows) => {
        const strictRows = this.applyStrictStatusFilter(rows, rptqry);
        this.itemsArray.push(strictRows);
        this.totalRows.push(strictRows.length);
        this.perPage.push(10);
        this.currentPage.push(1);
        this.tabIndex = this.tabsArray.length;
        this.isLoading = false;
      }).catch((err) => {
        logger.error(err);
        this.isLoading = false;
      });
      //this.itemsArray.push(this.customerInfo[i]);
    },
    convertToPdf(index) {
      if (!this.itemsArray[index] || this.itemsArray[index].length === 0) {
        return;
      }

      var pdf = new jsPDF("l", "pt");
      var board_name =
        "MAHARASHTRA RAJYA ITAR MAGASVARGIYA VITTA ANI VIKAS MAHAMANDAL LTD.";

      pdf.setFontSize(14);
      pdf.text(board_name.toUpperCase(), pdf.internal.pageSize.width / 2, 30, {
        align: "center",
      });

      pdf.setFontSize(12);
      pdf.text(this.tabsNames[index], pdf.internal.pageSize.width / 2, 50, {
        align: "center",
      });
      // pdf.text(this.tabsNames[index], 250, 100);
      var vc = this;
      let rw = vc.itemsArray[index][0];
      let hdr = [];
      for (var x in rw) {
        hdr.push({ header: x, dataKey: x });
      }
      const addFooters = (pdf) => {
        const pageCount = pdf.internal.getNumberOfPages();

        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        for (var i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          pdf.text(
            "Page " + String(i) + " of " + String(pageCount),
            pdf.internal.pageSize.width / 2,
            580,
            {
              align: "center",
            }
          );
        }
      };

      pdf.autoTable({
        columns: hdr,
        startY: 70,
        body: vc.itemsArray[index],
      });
      addFooters(pdf);

      pdf.save("Report.pdf");
    },
    convertToPassbook(index) {
      if (!this.itemsArray[index] || this.itemsArray[index].length === 0) {
        return;
      }

      const pdf = new jsPDF("l", "pt");
      const board_name = "MAHARASHTRA RAJYA ITAR MAGASVARGIYA VITTA ANI VIKAS MAHAMANDAL LTD.";
      const rows = this.itemsArray[index];
      const firstRow = rows[0] || {};
      const columns = Object.keys(firstRow).map((key) => ({ header: key, dataKey: key }));

      pdf.setFontSize(14);
      pdf.text(board_name.toUpperCase(), pdf.internal.pageSize.width / 2, 30, { align: "center" });
      pdf.setFontSize(12);
      pdf.text((this.tabsNames[index] || "Bank Passbook").toUpperCase(), pdf.internal.pageSize.width / 2, 50, { align: "center" });

      const addFooters = () => {
        const pageCount = pdf.internal.getNumberOfPages();
        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        for (let i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          pdf.text("Page " + String(i) + " of " + String(pageCount), pdf.internal.pageSize.width / 2, 580, { align: "center" });
        }
      };

      pdf.autoTable({
        columns,
        startY: 70,
        body: rows,
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: { fillColor: [47, 74, 144] },
        didParseCell: (data) => {
          if (data.section !== "body") return;
          if (data.column && data.column.dataKey === "ValidationStatus") {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.textColor = data.cell.raw === "Mismatch" ? [192, 57, 43] : [39, 174, 96];
          }
        }
      });

      addFooters();
      pdf.save("Bank_Passbook_Report.pdf");
    },
    // downloadExcel(index) {
    //   let app_data = this.itemsArray[index];

    //   var vc = this;
    //   var wb = XLSX.utils.book_new();
    //   var ws = XLSX.utils.json_to_sheet(app_data);

    //   XLSX.utils.book_append_sheet(wb, ws, "Applications");
    //   XLSX.writeFile(wb, "report.xlsx");
    // }
  },

  mounted() {
    //this.get_board_details();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ReportViewer/ReportViewer.vue